var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "68", height: "68", viewBox: "0 0 68 68", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg778816522a)", fill: "#F6B788" },
      React.createElement("path", { d: "M42.23 37.295h-4.043c.084.322.169 1.339.18 1.41.343 1.956-.878 2.953-2.15 3.376-4.79 1.597-6.23-4.786-6.23-4.786h-1.471v9.572h8.375v2.393h22.733v-2.393H68V24.134H51.944L42.23 37.295zm19.787 0h-11.23l4.906-7.179h6.324v7.18zM63.812 51.653H31.507c-2.643 0-5.384 1.545-5.384 4.188v4.786c0 2.643 2.741 5.384 5.384 5.384h32.305c2.643 0 4.188-2.741 4.188-5.384V55.84c0-2.643-1.545-4.188-4.188-4.188zm-.598 9.572H30.91v-4.786h32.305v4.786zM10.274 38.061a3.02 3.02 0 0 1-.574.914 2.995 2.995 0 0 1-2.178.95c-.272 0-.544-.038-.809-.112a2.966 2.966 0 0 1-2.135-3.325c.019-.122.03-.246.066-.367l.173-.455-.534.301C2.325 37.074-.007 39.5 0 44.78c.01 8.624 8.079 10.013 8.16 10.028l.43.068 2.023-3.98-.339-12.834zM9.361 56.421l3.157 1.709 1.139-2.105-1.448-4.866-2.848 5.262z" }),
      React.createElement("path", { d: "M33.243 39.63c.223.374.956 1.345 2.433.59.71-.364.71-1.103.71-1.507 0-1.185-7.87-24.45-7.87-24.45l-5.199 5.579 9.926 19.789zM26.613 3.827l.003-.428-2.488-1.41-.493.279-.989.561-.897.509-.651.368L16.87 6.1 6.011 34.69l-.233.612c-.114.412-.056.895.178 1.314.235.419.619.72 1.08.849.938.264 1.955-.316 2.213-1.24l.037-.078.05-.107 12.6-17.81.395-.56.396-.56 3.843-5.431.042-7.852zm-4.528 6.237a1.784 1.784 0 1 1 0-3.567 1.784 1.784 0 0 1 0 3.567z" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg778816522a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h68v68H0z" })
      )
    )
  );
});